import clsx from "clsx"
import React, { useState, useEffect } from "react"
import {
    Divider,
    Table,
    TableCell,
    TableBody,
    makeStyles,
    TableRow,
    Typography,
    IconButton,
    Grid,
} from "@material-ui/core"
import { useDateTime } from "shared/Modules/Localization/useDateTime"
import RightArrowIcon from "../../Components/RightArrowIcon"
import { PaymentMethodIcon } from "shared/Modules/Transaction/Components/PaymentMethodDrawer"
import { useMoney } from "shared/Modules/Localization/useMoney"
import { toDinero } from "shared/Helpers/CurrencyHelper"
import { LocalizedStrict } from "shared/Modules/Localization/Components/Localized"
import {
    IMeetingServiceOrder
} from "shared/Types/MeetingPlanning/meetingServiceOrders"
import DetailedMeetingReceiptModal from "../../../shared/Modules/OrderDetails/Screens/DetailedMeetingReceiptModal"
import { CurrentEnvironment } from "../../../shared/Modules/Environment/envTypes"

const useStyles = makeStyles((theme) => ({
    tableRow: {
        height: 48,
    },
    tableCell: {
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5),
    },
    tableCellIcon: {
        width: theme.spacing(6),
        textAlign: "center",
        paddingRight: theme.spacing(1.5),
        "& .fa-xl": {
            fontSize: "1.75em",
        },
    },
    tableCellArrowIcon: {
        width: theme.spacing(5),
    },
    button: {
        width: "calc(100% - 30px)",
        marginTop: theme.spacing(2),
        paddingBottom: 50,
    },
    resultAmount: {
        marginBottom: theme.spacing(4),
    },
    withoutBorderBottom: {
        borderBottom: "none",
    },
    paymentMethodIcon: {
        display: "inline-block",
        width: theme.spacing(2.5),
        height: theme.spacing(2.5),
        objectFit: "contain",
        objectPosition: "center",
    },
    greyColor: {
        color: theme.palette.grey[600],
    },
    totalText: {
        fontWeight: "bold",
    },
}))

interface IProps {
    initialData: IMeetingServiceOrder[]
    token: string
    environment: CurrentEnvironment
}

export default function MyMeetingServiceOrdersData(props: IProps) {
    const dateTimeFactory = useDateTime()
    const classes = useStyles()
    const moneyFactory = useMoney()
    const [data, setData] = useState<IMeetingServiceOrder[]>([])
    const [meetingReceiptOrder, setMeetingReceiptOrder] = useState<IMeetingServiceOrder>()

    useEffect(() => {
        setData(props.initialData)
    }, [props.initialData])

    function showMeetingDetails(order: IMeetingServiceOrder) {
        setMeetingReceiptOrder(order)
    }

    return (
        <>
            <LocalizedStrict id="my-orders-results" vars={{ amount: data.length }}>
                <Typography component="p" variant="caption" color="textSecondary" className={classes.resultAmount}>
                    {`${data.length} resultater`}
                </Typography>
            </LocalizedStrict>

            <Divider />
            <Table padding="none" cellPadding="none">
                <TableBody>
                    {data.map((order, index) => (
                        <TableRow key={index} className={classes.tableRow} onClick={() => showMeetingDetails(order)}>
                            <TableCell className={clsx(classes.tableCell, classes.tableCellIcon)}>
                                <PaymentMethodIcon iconDetails={{
                                    type: "IMAGE_URL",
                                    url: "https://facilitynet.dk/remote/gopay/payment-icons/payroll.svg"
                                }} />
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                                <Typography variant="body2">
                                    {order?.deliveryDetails?.time
                                        ? dateTimeFactory.formatDate(
                                              dateTimeFactory.fromISO(order.deliveryDetails.time.replace(' ', 'T'))
                                          )
                                        : ""}
                                </Typography>
                                <Typography variant="body2" className={classes.greyColor}>
                                    {order?.meetingDetails?.meetingName}
                                </Typography>
                            </TableCell>
                            <TableCell align="right" className={classes.tableCell}>
                                <Typography>{moneyFactory.formatAsNumber(toDinero(order.amount))}</Typography>
                            </TableCell>
                            <TableCell align="right" className={clsx(classes.tableCell, classes.tableCellArrowIcon)}>
                                <IconButton>
                                    <RightArrowIcon />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            {meetingReceiptOrder && (
                <DetailedMeetingReceiptModal
                    token={props.token}
                    environment={props.environment}
                    order={meetingReceiptOrder}
                    open={meetingReceiptOrder !== undefined}
                    onClose={() => setMeetingReceiptOrder(undefined)}
                />
            )}
        </>
    )
}
